import { render } from "./ListNotificationTemplates.vue?vue&type=template&id=72f25e06&scoped=true"
import script from "./ListNotificationTemplates.js?vue&type=script&lang=js"
export * from "./ListNotificationTemplates.js?vue&type=script&lang=js"

import "./ListNotificationTemplates.scss?vue&type=style&index=0&id=72f25e06&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f25e06"]])

export default __exports__